"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserLoggedIn = isUserLoggedIn;
function isUserLoggedIn(state) {
    return state.platform.user?.status === 'done';
}
